import { type Option } from '@allesauto/core/searchDropdown';

import {
  DELETE_FILTER_EQUIPMENT,
  SET_FILTER_EQUIPMENT,
} from '@/store/redux/actions/pages/pcp';
import {
  deleteFromFilterArrayHandler,
  IReduxActionProps,
} from '@/store/redux/Utils';

import { RESET_FILTER_EQUIPMENT } from './../../../../../actions/pages/pcp/filters/equipment/index';

export interface EquipmentFilterState {
  aircon: string[];
  comfort: string[];
  security: string[];
  entertainment: string[];
}

export interface EquipmentFilterStateProps {
  aircon: string[];
  comfort: Option[];
  security: Option[];
  entertainment: Option[];
}

export const InitialEquipmentFilterState: EquipmentFilterStateProps = {
  aircon: [],
  comfort: [],
  security: [],
  entertainment: [],
};

const EquipmentState = (
  state: EquipmentFilterStateProps = InitialEquipmentFilterState,
  action: IReduxActionProps
) => {
  const value = action.payload as EquipmentFilterStateProps;
  switch (action.type) {
    case SET_FILTER_EQUIPMENT: {
      return {
        ...state,
        ...value,
      };
    }
    case DELETE_FILTER_EQUIPMENT: {
      return (
        action.payload && deleteFromFilterArrayHandler(state, action.payload)
      );
    }
    case RESET_FILTER_EQUIPMENT:
      return InitialEquipmentFilterState;
    default:
      return state;
  }
};

export default EquipmentState;
